export let PredecessorType;
(function (PredecessorType) {
  PredecessorType["FF"] = "ff";
  PredecessorType["FS"] = "fs";
  PredecessorType["SF"] = "sf";
  PredecessorType["SS"] = "ss";
})(PredecessorType || (PredecessorType = {}));
//# sourceMappingURL=Predecessor.js.map